//import { ToastPlugin } from 'bootstrap-vue';
import Vue from 'vue';
import VueRouter from 'vue-router';

import toast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
Vue.use(toast, {
	position: 'bottom',
});
//import store from '../store';

Vue.use(VueRouter);

const router = new VueRouter({
	mode: 'history',
	routes: [
		{
			path: '/',
			component: () => import('@/views/MainPage.vue'),
			beforeEnter(to, from, next) {
				//router.app.$session.exists() ? next() : next('/login?backUri=' + from.path);
				if (router.app.$session.exists()) {
					//console.log('test1', from, to);
					next();
				} else {
					//console.log('test2', from, to);
					next('/login?backUri=' + to.path);
				}
			},
			children: [
				{
					path: '/',
					component: () => import('@/views/Home.vue'),
					meta: { title: 'Bwise ERP' },
					//meta: { auth: true },
				},

				// 아이템 관련
				{
					name: 'itemMaster',
					path: '/item/item_master',
					component: () => import('@/views/item/ItemMaster.vue'),
					meta: { title: 'Item Master' },
					// component: () => import('@/views/item/StimulTest.vue'),
				},
				{
					path: '/item/item_class',
					component: () => import('@/views/item/ItemClass.vue'),
					meta: { title: 'Item Class/Style' },
				},
				{
					name: 'inventoryHistory',
					path: '/item/inventory_history',
					component: () => import('@/views/item/InventoryHistory.vue'),
					meta: { title: 'Inventory History' },
					props: true,
				},
				{
					name: 'inventoryDetail',
					path: '/item/inventory_detail',
					component: () => import('@/views/item/InventoryDetail.vue'),
					meta: { title: 'Inventory Detail' },
					props: true,
				},
				{
					name: 'inventoryStatus',
					path: '/item/inventory_status',
					component: () => import('@/views/item/InventoryStatus.vue'),
					meta: { title: 'Inventory Status' },
					props: true,
				},
				{
					path: '/item/cost_adjust',
					component: () => import('@/views/item/CostAdjust.vue'),
					meta: { title: 'Cost Adjustment' },
					props: true,
				},
				{
					path: '/item/stock_adjust',
					component: () => import('@/views/item/StockAdjust.vue'),
					meta: { title: 'Stock Adjustment' },
					props: true,
				},
				{
					path: '/item/inventory_adjust',
					component: () => import('@/views/item/InventoryAdjust.vue'),
					meta: { title: 'Inventory Adjustment' },
					props: true,
				},
				{
					path: '/item/inventory_transaction',
					component: () => import('@/views/item/InventoryTransaction.vue'),
					meta: { title: 'Inventory Transaction' },
					props: true,
				},
				{
					path: '/item/repack',
					component: () => import('@/views/item/Repack.vue'),
					meta: { title: 'Repacking / Subdivision' },
					props: true,
				},
				{
					name: 'inventoryCounting',
					path: '/item/inventory_counting',
					component: () => import('@/views/item/InventoryCounting.vue'),
					meta: { title: 'Inventory Counting' },
					props: true,
				},
				{
					name: 'labelPrint',
					path: '/item/label_print',
					component: () => import('@/views/item/LabelPrint.vue'),
					meta: { title: 'Label Print' },
					props: true,
				},
				{
					path: '/item/item_list',
					component: () => import('@/views/item/ItemList.vue'),
					meta: { title: 'Item List' },
					// component: () => import('@/views/item/StimulTest.vue'),
				},
				{
					path: '/item/item_block',
					component: () => import('@/views/item/ItemBlock.vue'),
					meta: { title: 'Item Block' },
					// component: () => import('@/views/item/StimulTest.vue'),
				},
				{
					path: '/item/item_designation',
					component: () => import('@/views/item/ItemDesignation.vue'),
					meta: { title: 'Item Designation' },
					// component: () => import('@/views/item/StimulTest.vue'),
				},
				{
					path: '/item/user_defined_group',
					component: () => import('@/views/item/UserDefinedGroup/UserDefinedGroupMain.vue'),
					meta: { title: 'Item User Defined Group' },
				},
				{
					path: '/item/stock_vs_reorder',
					component: () => import('@/views/item/StockVSReorder.vue'),
					meta: { title: 'Item Stock vs. Reorder' },
				},

				// PO 관련
				{
					path: '/purchase/po_main',
					component: () => import('@/views/purchase/PurchaseMain.vue'),
					meta: { title: 'Purchase Order List' },
				},
				{
					name: 'purchaseDetail',
					path: '/purchase/po/:mode',
					component: () => import('@/views/purchase/PurchaseDetail.vue'),
					meta: { title: 'Purchase Order Detail' },
					props: true,
				},
				{
					path: '/purchase/shipment_main',
					component: () => import('@/views/purchase/ShipmentMain.vue'),
					meta: { title: 'Shipment List' },
				},
				{
					name: 'shipmentDetail',
					path: '/purchase/shipment/:mode',
					component: () => import('@/views/purchase/ShipmentDetail.vue'),
					meta: { title: 'Shipment Detail' },
					props: true,
				},
				{
					name: 'PreReceiving',
					path: '/purchase/preReceiving',
					component: () => import('@/views/purchase/PreReceiving.vue'),
					meta: { title: 'PO PreReceiving' },
				},
				{
					name: 'Received List',
					path: '/purchase/receivedList',
					component: () => import('@/views/purchase/ReceivedList.vue'),
					meta: { title: 'PO Received List' },
				},
				{
					name: 'Received Goods',
					path: '/purchase/receivedGoods',
					component: () => import('@/views/purchase/ReceivedGoods.vue'),
					meta: { title: 'PO Received Goods' },
				},
				{
					path: '/purchase/slip',
					component: () => import('@/views/purchase/SlipMain.vue'),
					meta: { title: 'Slip List' },
				},
				{
					name: 'slipDetail',
					path: '/purchase/slip/:mode',
					component: () => import('@/views/purchase/SlipDetail.vue'),
					meta: { title: 'Slip Detail' },
					props: true,
				},
				{
					name: 'onOrderDetail',
					path: '/purchase/on_order_detail',
					component: () => import('@/views/purchase/OnOrderDetail.vue'),
					meta: { title: 'PO On Order Detail' },
				},
				{
					path: '/purchase/on_board_schedule',
					component: () => import('@/views/purchase/OnBoardSchedule.vue'),
					meta: { title: 'PO On Board Schedule' },
				},
				{
					path: '/purchase/last_shipment_price',
					component: () => import('@/views/purchase/LastShipmentPrice.vue'),
					meta: { title: 'Last Shipment Price' },
				},

				// Sales 관련
				{
					name: 'soMain',
					path: '/sales/so_main',
					component: () => import('@/views/sales/SoMain.vue'),
					meta: { title: 'Sales Order List' },
				},
				{
					name: 'soDetail',
					path: '/sales/so/:mode',
					component: () => import('@/views/sales/SoDetail.vue'),
					meta: { title: 'Sales Order Detail' },
					props: true,
				},
				{
					name: 'whReturn',
					path: '/sales/wh_return',
					component: () => import('@/views/sales/WhReturnMain.vue'),
					meta: { title: 'Warehouse Return' },
				},
				{
					name: 'whReturnDetail',
					path: '/sales/wh_return/:mode',
					component: () => import('@/views/sales/WhReturnDetail.vue'),
					meta: { title: 'Warehouse Return Detail' },
					props: true,
				},
				{
					path: '/sales/request_price',
					component: () => import('@/views/sales/RequestPrice.vue'),
					meta: { title: 'SO Approval' },
				},
				{
					path: '/sales/packing_status',
					component: () => import('@/views/sales/PackingStatus.vue'),
					meta: { title: 'Packing Status' },
				},
				{
					path: '/sales/pickup',
					component: () => import('@/views/sales/Pickup.vue'),
					meta: { title: 'Pick Up' },
				},
				{
					name: 'boxing',
					path: '/sales/boxing',
					component: () => import('@/views/sales/Boxing.vue'),
					meta: { title: 'Packing' },
					props: true,
				},
				{
					name: 'warehouseMemo',
					path: '/sales/warehouse_memo',
					component: () => import('@/views/sales/WarehouseMemo.vue'),
					meta: { title: 'Warehouse Memo' },
				},
				{
					name: 'invoiceMain',
					path: '/sales/invoice_main',
					component: () => import('@/views/sales/InvoiceMain.vue'),
					meta: { title: 'Invoice List' },
				},
				{
					name: 'invoiceDetail',
					path: '/sales/invoice/:mode',
					component: () => import('@/views/sales/InvoiceDetail.vue'),
					meta: { title: 'Invoice Detail' },
					props: true,
				},
				{
					name: 'backOrder',
					path: '/sales/back_order',
					component: () => import('@/views/sales/BackOrder.vue'),
					meta: { title: 'Back Order' },
				},
				{
					name: 'callTag',
					path: '/sales/call_tag',
					component: () => import('@/views/sales/CallTag.vue'),
					meta: { title: 'Call Tag List' },
				},
				{
					name: 'callTagDetail',
					path: '/sales/call_tag/:mode',
					component: () => import('@/views/sales/CallTagDetail.vue'),
					meta: { title: 'Call Tag Detail' },
					props: true,
				},
				{
					name: 'sampleInout',
					path: '/sales/sample/inout',
					component: () => import('@/views/sales/SampleInout.vue'),
					meta: { title: 'Sample In / Out' },
					props: true,
				},
				{
					path: '/sales/sample',
					component: () => import('@/views/sales/SampleMain.vue'),
					meta: { title: 'Sample List' },
				},
				{
					name: 'sampleDetail',
					path: '/sales/sample/:mode',
					component: () => import('@/views/sales/SampleDetail.vue'),
					meta: { title: 'Sample Detail' },
					props: true,
				},
				{
					name: 'samplePickup',
					path: '/sales/sample_pickup',
					component: () => import('@/views/sales/SamplePickup.vue'),
					meta: { title: 'Sample Pick Up' },
					props: true,
				},
				{
					name: 'retailMain',
					path: 'sales/retail/main',
					component: () => import('@/views/sales/retailStore/RetailStore.vue'),
					meta: { title: 'Retail Order List' },
					props: true,
				},
				{
					name: 'retailDetail',
					path: 'sales/retail/detail',
					component: () => import('@/views/sales/retailStore/RetailStoreDetail.vue'),
					meta: { title: 'Retail Order Detail' },
					props: true,
				},
				{
					path: '/sales/delayed_invoice',
					component: () => import('@/views/sales/DelayedInvoice.vue'),
					meta: { title: 'Delayed SO / Invoice' },
				},
				{
					path: '/sales/promotion',
					component: () => import('@/views/sales/Promotion.vue'),
					meta: { title: 'Promotion' },
				},

				// AR 관련
				{
					path: '/receipt/ar_main',
					component: () => import('@/views/receipt/ArMain.vue'),
					meta: { title: 'AR Main' },
				},
				{
					name: 'arHistory',
					path: '/receipt/ar_history',
					component: () => import('@/views/receipt/ArHistory.vue'),
					meta: { title: 'AR History' },
				},
				{
					name: 'arCheck',
					path: '/receipt/ar_check',
					component: () => import('@/views/receipt/ArCheck.vue'),
					meta: { title: 'Check Settlement' },
				},
				{
					path: '/receipt/ar_reverse',
					component: () => import('@/views/receipt/ArReverse.vue'),
					meta: { title: 'Payment Reverse' },
				},
				{
					name: 'bounceList',
					path: '/receipt/bounceList',
					component: () => import('@/views/receipt/BounceList.vue'),
					meta: { title: 'Bounce List' },
				},

				// AP 관련
				{
					path: '/payment/ap_main',
					component: () => import('@/views/payment/ApMain.vue'),
					meta: { title: 'AP Main' },
				},
				{
					name: 'apHistory',
					path: '/payment/ap_history',
					component: () => import('@/views/payment/ApHistory.vue'),
					meta: { title: 'AP History' },
				},
				{
					path: '/payment/ap_reverse',
					component: () => import('@/views/payment/ApReverse.vue'),
					meta: { title: 'Payment Reverse' },
				},

				// Partner 관련
				{
					name: 'partner',
					path: '/partner/partner_main',
					component: () => import('@/views/partner/Partners.vue'),
					beforeEnter(to, from, next) {
						next();
					},
					meta: { title: 'Partner List' },
				},
				{
					name: 'partner_simple',
					path: '/partner/partner_simple',
					component: () => import('@/views/partner/PartnersSimple.vue'),
					beforeEnter(to, from, next) {
						next();
					},
					meta: { title: 'Partner Info (Simple)' },
				},
				{
					name: 'customers',
					path: '/partner/customer_main',
					component: () => import('@/views/partner/Partners.vue'),
					meta: { title: 'Customer List', initial_partner_type: 'C' },
				},
				{
					name: 'vendors',
					path: '/partner/vendor_main',
					component: () => import('@/views/partner/Partners.vue'),
					meta: { title: 'Vendor List', initial_partner_type: 'V' },
				},
				{
					name: 'partnerDetail',
					path: '/partner/:mode',
					component: () => import('@/views/partner/PartnerDetail.vue'),
					meta: { title: 'Partner Detail' },
					props: true,
				},
				{
					path: '/sc/sc_main',
					component: () => import('@/views/partner/ScMain.vue'),
					meta: { title: 'Store Credit List' },
				},
				{
					name: 'scDetail',
					path: '/sc/:mode',
					component: () => import('@/views/partner/ScDetail.vue'),
					meta: { title: 'Store Credit Detail' },
					props: true,
				},

				// Daily Closing 관련
				{
					path: '/dc/login_id_scan',
					component: () => import('@/views/dc/LoginIdScan.vue'),
					meta: { title: 'Login ID Scan' },
				},

				// Report 관련
				{
					path: '/report/dashboard',
					component: () => import('@/views/statistics/HomeGraphSection.vue'),
					meta: { title: 'Dashboard' },
				},
				{
					path: '/report/arAging',
					component: () => import('@/views/report/arAging.vue'),
					meta: { title: 'AR Aging' },
				},
				{
					path: '/report/receiptType',
					component: () => import('@/views/report/ReceiptType/ReceiptType.vue'),
					meta: { title: 'Receipt By Type' },
				},
				{
					path: '/report/balanceBySalesGroup',
					component: () => import('@/views/report/balanceBySalesGroup.vue'),
					meta: { title: 'AR By SalesGroup' },
				},
				{
					path: '/report/ar_balance_for_bank',
					component: () => import('@/views/report/ArBalanceForBank.vue'),
					meta: { title: 'AR For Bank' },
				},
				{
					path: '/report/ar_balance_for_cpa',
					component: () => import('@/views/report/ArBalanceForCPA.vue'),
					meta: { title: 'AR For CPA' },
				},
				{
					path: '/report/packingStatus',
					component: () => import('@/views/report/packingStatus.vue'),
					meta: { title: 'Packing Status Report' },
				},
				{
					path: '/report/immediatePayment',
					component: () => import('@/views/report/immediatePayment.vue'),
					meta: { title: 'Immediate Payment' },
				},
				{
					path: '/report/salesTemplate',
					component: () => import('@/views/report/salesTemplate.vue'),
					meta: { title: 'Sales Template(Month)' },
				},
				{
					path: '/report/salesTemplate/yearly',
					component: () => import('@/views/report/SalesTemplateYearly.vue'),
					meta: { title: 'Sales Template(Year)' },
				},
				{
					path: '/report/salesReturnReceipt',
					component: () => import('@/views/report/salesReturnReceipt.vue'),
					meta: { title: 'Sales/Return/Receipt' },
				},
				{
					path: '/report/salesByState',
					component: () => import('@/views/report/SalesByState.vue'),
					meta: { title: 'Sales by State' },
				},
				{
					path: '/report/salesByCustomer',
					component: () => import('@/views/report/SalesByCustomer.vue'),
					meta: { title: 'Sales by Customer' },
				},
				{
					path: '/report/salesOrderList',
					component: () => import('@/views/report/salesOrderList.vue'),
					meta: { title: 'Sales Order List' },
				},
				{
					path: '/report/first_sale',
					component: () => import('@/views/report/FirstSale.vue'),
					meta: { title: 'First Sale' },
				},
				{
					path: '/report/vendorAnalyze/item',
					component: () => import('@/views/report/vendorAnalyze/item.vue'),
					meta: { title: 'Vendor Analyze' },
				},
				{
					path: '/report/selectPurchaseByVendor',
					component: () => import('@/views/report/PurchaseByVendor.vue'),
					meta: { title: 'Purchase by Vendor' },
				},
				{
					path: '/report/purchase_history_by_goods',
					component: () => import('@/views/report/PurchaseHistoryByGoods.vue'),
					meta: { title: 'Purchase History by Goods' },
				},
				{
					path: '/report/annual_history_by_goods',
					component: () => import('@/views/report/AnnualHistoryByGoods.vue'),
					meta: { title: 'Annual History by Goods' },
				},
				{
					path: '/report/item_aging',
					component: () => import('@/views/report/ItemAging.vue'),
					meta: { title: 'Item Aging' },
				},
				{
					name: 'itemInquiry',
					path: '/report/item_inquiry',
					component: () => import('@/views/report/ItemInquiry.vue'),
					meta: { title: 'Item Inquiry' },
				},
				{
					name: 'salesGoods',
					path: '/report/sales_goods',
					component: () => import('@/views/report/SalesGoods.vue'),
					meta: { title: 'Sales Goods' },
				},
				{
					path: '/report/sales_goods_by_salesGroup',
					component: () => import('@/views/report/SalesGoodsBySalesGroup.vue'),
					meta: { title: 'Sales Goods by S.Group' },
				},
				{
					path: '/report/salesTopRecordClass',
					component: () => import('@/views/report/SalesTopRecode/SalesTopRecordClass.vue'),
					meta: { title: 'Sales Top Record Class' },
				},
				{
					path: '/report/salesTopRecordCustomer',
					component: () => import('@/views/report/SalesTopRecode/SalesTopRecordCustomer.vue'),
					meta: { title: 'Sales Top Record Cust.' },
				},
				{
					path: '/report/scanned_SO_items',
					component: () => import('@/views/report/ScannedSOItems.vue'),
					meta: { title: 'Scanned S/O Items' },
				},
				{
					path: '/report/customer_list_with_no_certain_items',
					component: () => import('@/views/report/CustomersWOItems.vue'),
					meta: { title: 'Cust. w/o Certain Items' },
				},
				{
					path: '/report/landingRates',
					component: () => import('@/views/report/LandingRates.vue'),
					meta: { title: 'Landing Rates' },
				},
				{
					path: '/report/landingRegion',
					component: () => import('@/views/report/LandingRegion.vue'),
					meta: { title: 'Landing Region' },
				},
				{
					path: '/report/landingRegionGroup',
					component: () => import('@/views/report/LandingRegionGroup.vue'),
					meta: { title: 'Landing Region Group' },
				},
				{
					path: '/report/approved/back-order',
					component: () => import('@/views/report/ApprovedBackOrder.vue'),
					meta: { title: 'Approved Back Order' },
				},
				{
					path: '/report/inventory-sheet',
					component: () => import('@/views/report/InventorySheet.vue'),
					meta: { title: 'Inventory Sheet' },
				},
				{
					path: '/report/packing_per_staff',
					component: () => import('@/views/report/PackingPerStaff.vue'),
					meta: { title: 'Packing per Staff' },
				},
				{
					path: '/report/daily_sales_progress',
					component: () => import('@/views/report/DailySalesProgress.vue'),
					meta: { title: 'Daily Sales Progress' },
				},
				{
					path: '/report/ar_notification_log',
					component: () => import('@/views/report/NotificationLog.vue'),
					meta: { title: 'AR Notification Log' },
				},
				{
					path: '/report/gps_log',
					component: () => import('@/views/report/GpsLog.vue'),
					meta: { title: 'GPS Log' },
				},
				{
					path: '/report/login_log',
					component: () => import('@/views/report/LoginLog.vue'),
					meta: { title: 'Login Log' },
				},

				{
					path: '/report/no-certain-item-customer',
					component: () => import('@/views/report/NoCertainItemsCustomer.vue'),
				},
				{
					path: '/report/customer-statement',
					component: () => import('@/views/report/CustomerStatement.vue'),
				},
				{
					path: '/report/mail-log',
					name: 'mailLog',
					component: () => import('@/views/report/MailLog.vue'),
					meta: { title: 'Mail Log', subTitle: 'Report -> Mail Log' },
				},
				//유저 관리
				{
					path: '/basic_info/user',
					component: () => import('@/views/basicinformation/Users.vue'),
					meta: { title: 'User List' },
				},
				{
					name: 'userDetail',
					path: '/basic_info/user/:mode',
					component: () => import('@/views/basicinformation/UserDetail.vue'),
					meta: { title: 'User Detail' },
					props: true,
				},
				// {
				// 	path: '/basic_info/salesteam',
				// 	component: () => import('@/views/basicinformation/SalesTeam.vue'),
				// },
				{
					path: '/basic_info/salesgroup',
					component: () => import('@/views/basicinformation/SalesGroup.vue'),
					meta: { title: 'Sales Group' },
				},
				{
					path: '/basic_info/code',
					component: () => import('@/views/basicinformation/CodePage.vue'),
					meta: { title: 'Code' },
				},
				{
					path: '/basic_info/zone',
					component: () => import('@/views/basicinformation/ZonePage.vue'),
					meta: { title: 'Zone' },
				},
				{
					path: '/basic_info/zipcode',
					component: () => import('@/views/basicinformation/Zipcode.vue'),
					meta: { title: 'Zipcode' },
				},
				{
					path: '/basic_info/shipment',
					component: () => import('@/views/basicinformation/Shipment.vue'),
					meta: { title: 'Shipment Info.' },
				},
				{
					path: '/basic_info/pick_order',
					component: () => import('@/views/basicinformation/PickOrder.vue'),
					meta: { title: 'Pick Order' },
				},
				{
					path: '/basic_info/settings',
					component: () => import('@/views/basicinformation/Settings.vue'),
					meta: { title: 'Settings' },
				},
				{
					path: '/basic_info/system_settings',
					component: () => import('@/views/basicinformation/SystemSettings.vue'),
					meta: { title: 'System Settings' },
				},

				{
					path: '/basic_info/global_settings',
					component: () => import('@/views/basicinformation/GlobalSettings.vue'),
					meta: { title: 'Global Settings' },
				},
				{
					name: 'noticeForm',
					path: '/basic_info/notices/:mode',
					component: () => import('@/views/basicinformation/notice/NoticeForm.vue'),
					props: true,
				},
				// shopify
				{
					name: 'shopifyOrder',
					path: '/sales/shopify',
					component: () => import('@/views/shopify/ShopifyOrder.vue'),
					meta: { title: 'Shopify Order' },
				},
				{
					name: 'shopifyItem',
					path: '/item/shopify',
					component: () => import('@/views/shopify/ShopifyItem.vue'),
					meta: { title: 'Shopify Item' },
				},

				//Mobile 화면
				// {
				// 	path: '/mobile',
				// 	component: () => import('@/views/mobile/MobileHome.vue'),
				// },
			],
			// meta: { auth: true },
		},
		{
			name: 'StatusOfGoal',
			path: '/warehouse/status_of_goal',
			component: () => import('@/views/report/StatusOfGoal.vue'),
			meta: { title: 'Status Of Goal' },
		},
		{
			path: '/health',
			component: () => import('@/views/Health.vue'),
		},
		{
			name: 'error',
			path: '/error',
			component: () => import('@/views/Error.vue'),
			props: true,
		},
		{
			name: 'accessError',
			path: '/access_error',
			component: () => import('@/views/AccessError.vue'),
			props: true,
		},
		{
			name: 'login',
			path: '/login',
			component: () => import('@/views/Login.vue'),
			props: true,
		},
		// {
		// 	name: 'apiGetUser',
		// 	path: '/api/get_user',
		// 	// beforeEnter(to) {
		// 	// 	console.log(to);
		// 	// 	//window.location = 'https://max-test.bwisesoft.com/api/get_user?phone_no=7187498905&user_id=choi&password=1';
		// 	// 	location.href = 'https://max-test.bwisesoft.com/api/get_user?phone_no=7187498905&user_id=choi&password=1';
		// 	// },
		// 	component: () => import('@/views/api/GetUser.vue'),
		// 	props: true,
		// },
		{
			path: '*',
			component: () => import('@/views/NotFoundPage.vue'),
		},
	],
	// beforeRouteUpdate(to, from, next) {
	// 	// just use `this`
	// 	//this.name = to.params.name;
	// 	//console.log(to);
	// 	next();
	// },
});

router.afterEach(to => {
	const title = to.meta.title === undefined ? 'BwiseERP' : to.meta.title;
	Vue.nextTick(() => {
		if (process.env.NODE_ENV == 'development') document.title = title + ' (DEV)';
		else document.title = title;
		//process.env.NODE_ENV == 'development'
	});
});

router.beforeEach((to, from, next) => {
	const session_user = router.app.$session.get('user');
	const restrictedPaths = ['/login', '/access_error', '/basic_info/settings', '/', '/basic_info/notices/detail', '/basic_info/code', '/basic_info/notices/add', '/basic_info/notices/update'];
	if (session_user && !restrictedPaths.includes(to.path)) {
		if (session_user.admin_yn === 'Y' || accessible()) {
			next();
		} else {
			Vue.$toast.error(`You don't have permission`);
			next(from);
		}
	}

	next();

	function accessible() {
		if (to.path === '/error') return true;
		const menus = router.app.$session.get('menus');
		if (menus) {
			for (let i = 0; i < menus.length; i++) {
				if (menus[i].path === to.path && menus[i].view_yn === 'Y') return true;
			}
		}
		return false;
	}
});

export default router;
